// extracted by mini-css-extract-plugin
export default {"loader":"UiLoading_loader__XCoga","shadow":"UiLoading_shadow__zmo3u"};